import { DOCUMENT, Injectable, effect, inject, signal } from '@angular/core';

const SIDEBAR_KEY = 'vintech.sidebarCollapsed';

const read = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};
const write = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode): preference just isn't remembered */
  }
};

/**
 * Sidebar state, remembered per browser. The app has a single light theme.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);

  readonly sidebarCollapsed = signal(read(SIDEBAR_KEY) === '1');
  /** Off-canvas sidebar on small screens. */
  readonly mobileSidebarOpen = signal(false);

  constructor() {
    this.document.documentElement.setAttribute('data-bs-theme', 'light');
    try { localStorage.removeItem('vintech.theme'); } catch { /* ignore */ }
    effect(() => write(SIDEBAR_KEY, this.sidebarCollapsed() ? '1' : '0'));
  }

  toggleSidebar(): void {
    if (window.matchMedia('(max-width: 991.98px)').matches) {
      this.mobileSidebarOpen.update((v) => !v);
    } else {
      this.sidebarCollapsed.update((v) => !v);
    }
  }
}
